"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomSubjectSchema = void 0;
const zod_1 = require("zod");
exports.CustomSubjectSchema = zod_1.default.object({
    id: zod_1.default.string(),
    buildId: zod_1.default.string(),
    customTypeName: zod_1.default.string(),
    subjectName: zod_1.default.string(),
    description: zod_1.default.string(),
    properties: zod_1.default.record(zod_1.default.string(), zod_1.default.unknown()).optional(),
});
//# sourceMappingURL=custom-subject.js.map